// src/utils/roleUtils.ts

/**
 * Check if user has any of the required roles
 * @param userRoles - Array of roles assigned to the user
 * @param requiredRoles - Array of roles that are allowed
 * @returns boolean - True if user has at least one required role
 */
export const hasRequiredRole = (userRoles: string[] = [], requiredRoles: string[] = []): boolean => {
  if (requiredRoles.length === 0) return true;
  return requiredRoles.some(role => userRoles.includes(role));
};

/**
 * Get the primary role of a user (admin > manager > staff > driver > warehouse > customer)
 * @param roles - Array of user roles
 * @returns string - The highest priority role
 */
export const getPrimaryRole = (roles: string[] = []): string => {
  const rolePriority = ['admin', 'manager', 'staff', 'driver', 'warehouse', 'customer'];
  return rolePriority.find(role => roles.includes(role)) || 'customer';
};

/**
 * Check if user has admin or manager level access
 */
export const isAdminOrManager = (roles: string[] = []): boolean => {
  return roles.some(role => ['admin', 'manager'].includes(role));
};

/**
 * Check if user is a customer only (no staff roles)
 */
export const isCustomerOnly = (roles: string[] = []): boolean => {
  return roles.length === 1 && roles[0] === 'customer';
};

/**
 * Filter users by role
 */
export const filterUsersByRole = (users: any[], role: string): any[] => {
  return users.filter(user => user.roles?.includes(role));
};

export const hasAnyRole = (userRoles: string[] = [], requiredRoles: string[] = []): boolean => {
  return requiredRoles.some(role => userRoles.includes(role));
};